import { useKpiData } from "./hooks/useKpiData";
import { useAddKpi } from "./hooks/useAddKpi";
import { useViewKpi } from "./hooks/useViewKpi";
import { useEditKpi } from "./hooks/useEditKpi";
import { useDeleteKpi } from "./hooks/useDeleteKpi";

export const useKpiController = () => {
  const kpiDataHook = useKpiData();

  const { currentPage, pageSize, viewMonthYear, addMonthYear, orgId, reportingManagerId, selectedDesignationId, fetchEmployeeList, fetchKpiData, setViewMode } = kpiDataHook;

  const refreshData = () => {
    fetchEmployeeList(1, pageSize);
    fetchKpiData(1, pageSize);
    setViewMode("view");
  };

  const addKpiHook = useAddKpi({
    monthYear: addMonthYear,
    orgId,
    reportingManagerId,
    selectedDesignationId,
    onSuccess: refreshData,
  });

  const viewKpiHook = useViewKpi({
    monthYear: viewMonthYear,
  });

  const editKpiHook = useEditKpi({
    monthYear: viewMonthYear,
    reportingManagerId,
    onSuccess: () => fetchKpiData(currentPage, pageSize),
  });

  const deleteKpiHook = useDeleteKpi({
    monthYear: viewMonthYear,
    reportingManagerId,
    onSuccess: () => fetchKpiData(currentPage, pageSize),
  });

  return {
    ...kpiDataHook,
    ...addKpiHook,
    ...viewKpiHook,
    ...editKpiHook,
    ...deleteKpiHook,
    selectedRowKeys: deleteKpiHook.selectedRowKeys,
    setSelectedRowKeys: deleteKpiHook.setSelectedRowKeys,

    loading: kpiDataHook.loading || addKpiHook.submitLoading,
    submitLoading: addKpiHook.submitLoading,

    selectedEmployee: addKpiHook.selectedEmployeeAdd || viewKpiHook.selectedEmployeeView || editKpiHook.selectedEmployeeEdit,
    modalLoading: addKpiHook.modalLoadingAdd || viewKpiHook.modalLoadingView || editKpiHook.modalLoadingEdit,
    viewKpiData: viewKpiHook.isViewKpiModalOpen ? viewKpiHook.viewKpiData : editKpiHook.viewKpiDataEdit,
  };
};
